import { eventConstants as constants } from "../_constants/event.constants";

export const initialState = {
  event: false,
  items: false,
  loading: false,
  initLoad: true,
  rescheduling: false,
}

export function event(state = initialState, action) {

  if (action.type === constants.EVENT_RESCHEDULING) {
    return {
      ...state,
      rescheduling: true,
    }
  }

  if (action.type === constants.EVENT_ADD_ITEM) {
    return {
      ...state,
      items: action.event.items,
      loading: false,
      initLoad: false,
    }
  }

  if (action.type === constants.EVENT_GET_SUCCESS) {
    return {
      ...state,
      event: action.event,
      items: action.event.items,
      loading: false,
      initLoad: false,
      rescheduling: false,
    }
  }

  if (action.type === constants.EVENT_GET_FAILURE) {
    return {
      ...state,
      loading: false,
      rescheduling: false,
    }
  }

  if (action.type === constants.EVENT_GET_REQUEST) {
    return {
      ...state,
      loading: true,
    }
  }

  if (action.type === constants.EVENT_INIT_LOAD) {
    return {
      ...state,
      initLoad: true,
    }
  }

  return state;
}